import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { setOrCreateNewActiveLayer } from '../../../../redux/active_layers/Actions';

import PanelContent from '../common/PanelContent';
import PanelActions from '../common/PanelActions';
import PanelDivider from '../common/PanelBorder';
import LandAssemblyAggregates from './LandAssemblyAggregates';
import LandAssemblyFeatureList from './LandAssemblyFeatureList';
import LandAssemblyActions from './LandAssemblyActions';
import SiteCardCreator from '../site/sitecard/SiteCardCreator';
import { closeSiteCardCreator, toggleLandAssemblyFeaturesAsync } from '../../../../redux/land_assembly/Actions';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import { setHighlightedFeatures } from '../../../../redux/highlights/Actions';
import LandAssemblySearchSettings from './LandAssemblySearchSettings';

const propTypes = {

};

const defaultProps = {

};

function LandAssemblyPanel () {
    const isCreatingSiteCard = useSelector(state => state.landAssembly.isCreatingSiteCard);
    const layerId = useSelector(state => state.landAssembly.layerId);
    const layer = useSelector(state => state.layers.layers.find(l => l.id === layerId));
    const features = useSelector(state => state.landAssembly.features);
    const featureIds = features.map(feature => feature.featureId);

    const dispatch = useDispatch();
    const dispatchSetLandAssemblyLayerActive = (layer) => dispatch(setOrCreateNewActiveLayer({
        uid: layer.system_name,
        systemName: layer.system_name,
        visible: true,
        printable: true
    }));
    const dispatchCloseSiteCardCreator = () => dispatch(closeSiteCardCreator());
    const dispatchSetHighlightedFeatures = (features) => dispatch(setHighlightedFeatures(features));
    const dispatchToggleLandAssemblyFeatures = (featureIds) => dispatch(toggleLandAssemblyFeaturesAsync(featureIds));

    if (isCreatingSiteCard && featureIds.length === 0) { console.error('Highlighted layer should have at least one feature'); }

    useEffect(() => {
        if (layer?.id != null) {
            dispatchSetLandAssemblyLayerActive(layer);
        }
        // ToDo - zoom to suitable level
    }, [layerId]);

    function handleCloseSiteCardCreator () {
        
        const highlightedFeatures = layer ? [{
            key: `${layer.system_name}_selected`,
            layerSystemName: layer.system_name,
            features: _.cloneDeep(features)
        }] : [];
        dispatchSetHighlightedFeatures(highlightedFeatures);
        // dispatchToggleLandAssemblyFeatures(features);
        dispatchCloseSiteCardCreator();
    }

    if (isCreatingSiteCard) {
        return (
            <SiteCardCreator
                featureConfig={{
                    layerId: layerId,
                    featureIds: featureIds
                }}
                defaultName="Land Assembly Site Card"
                onClose={handleCloseSiteCardCreator}
            />
        ); 
    }

    return (<>
        <PanelContent>
            <LandAssemblySearchSettings />
            <PanelDivider />
            <LandAssemblyFeatureList />
        </PanelContent>  
        <PanelDivider />
        <PanelActions>
            <LandAssemblyAggregates />
            <LandAssemblyActions />
        </PanelActions>
    </>);
}

LandAssemblyPanel.propTypes = propTypes;
LandAssemblyPanel.defaultProps = defaultProps;

export default LandAssemblyPanel;